import React from 'react'
import tick from '../../Images/Vector (22).png'
import cross from '../../Images/fi_18396607.png'
import QuarterlyComparePlan from './QuaterlyComparePlan'
import { openWhatsAppLink } from '../../Component/OpenWhatsApp'
const QuaterlyPlan = ({city,price,cycle}) => {
  return (
    <>
            <div className='pricing_plans_div_wrapper'>
      <div className='pricing_plans_div2'>
              <div className='d-flex justify-content-between align-items-center'>
              <p className='basic_plan_head text-light'>{city}</p>
              <button className='special_btn'>{cycle}</button>
              </div>
           
                {/* <p className='services_para text-light'>
                  <span className='text-light'>
                    05
                  </span>
                  Services
                </p> */}
                <p className='free_para text-light'>&#8377; {price}</p>
                <button
                onClick={(e) => openWhatsAppLink(e, "919876543210", "I am interested in Quaterly plan for Gurgaon")}
                className='plan_btn bg-light text-dark'>Choose Plan</button>
                <div className='price_plans_list'>
                  <div className='price_plan_list2'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para text-light'>100% Verified Owner’s Listings</p>
                  </div>

                  <div className='price_plan_list2'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para text-light'>Real-Time Weekly Updates</p>
                  </div>


                  <div className='price_plan_list2'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para text-light'>Exclusive U/C & Ready Properties</p>
                  </div>

                  <div className='price_plan_list2'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para text-light'>High-Quality Data with Images</p>
                  </div>

                  <div className='price_plan_list2'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para text-light'>Direct Owner & Seller Contacts</p>
                  </div>

                  <div className='price_plan_list2'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para text-light'>No Middlemen, No Brokers</p>
                  </div>

                  
                </div>
              </div>
              {0===1 && (
                <>
                  <div className='pricing_plans_div'>
                <p className='basic_plan_head'>Noida</p>
                {/* <p className='services_para'>
                  <span>
                    03
                  </span>
                  Services
                </p> */}
                <p className='free_para'>&#8377; 8,000</p>
                <button
                onClick={(e) => openWhatsAppLink(e, "919876543210", "I am interested in Quaterly plan for Noida")}
                className='plan_btn'>Get Started Free</button>
                <div className='price_plans_list'>
                  <div className='price_plan_list1'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para'>100% Verified Owner’s Listings</p>
                  </div>

                  <div className='price_plan_list1'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para'>Real-Time Weekly Updates</p>
                  </div>


                  <div className='price_plan_list1'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para'>Exclusive U/C & Ready Properties</p>
                  </div>

                  <div className='price_plan_list1'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para'>High-Quality Data with Images</p>
                  </div>

                  <div className='price_plan_list1 border_none'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para'>Direct Owner & Seller Contacts</p>
                  </div>


                  
                  <div className='price_plan_list1 border_none'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para'>No Middlemen, No Brokers</p>
                  </div>

                  
                </div>
              </div>
             
              <div className='pricing_plans_div'>
              <p className='basic_plan_head'>South Delhi</p>
                {/* <p className='services_para'>
                  <span>
                    07
                  </span>
                  Services
                </p> */}
                <p className='free_para'>&#8377; 8,000</p>
                <button
                onClick={(e) => openWhatsAppLink(e, "919876543210", "I am interested in Quaterly plan for South Delhi")}
                className='plan_btn'>Choose Plan</button>
                <div className='price_plans_list'>
                  <div className='price_plan_list1'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para'>100% Verified Owner’s Listings</p>
                  </div>

                  <div className='price_plan_list1'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para'>Real-Time Weekly Updates</p>
                  </div>


                  <div className='price_plan_list1'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para'>Exclusive U/C & Ready Properties</p>
                  </div>

                  <div className='price_plan_list1'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para'>High-Quality Data with Images</p>
                  </div>

                  <div className='price_plan_list1 border_none'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para'>Direct Owner & Seller Contacts</p>
                  </div>


                  
                  <div className='price_plan_list1 border_none'>
                    <div className='price_corret_div'>
                      <img src={tick}/>
                    </div>
                    <p className='customized_para'>No Middlemen, No Brokers</p>
                  </div>

                  
                </div>
              </div>
                </>
              )}
              </div>
           
    </>
  )
}

export default QuaterlyPlan
